<main class="flex flex-col gap-2">
  <section class="flex items-center max-w-full gap-3 overflow-x-auto">
    @if(images().length < 5){
    <button
      (click)="handleUpload()"
      class="flex flex-col flex-shrink-0 items-center gap-2 px-8 py-6 border border-neutral-200 rounded-xl size-[128px]"
    >
      <img src="icons/image_icon.svg" class="size-6" />
      <p class="text-sm text-neutral-400">
        파일 업로드
        <br />
        (최대 5장)
      </p>
    </button>
    } @for(image of images(); track $index){
    <div class="relative flex-shrink-0">
      <img
        [src]="image"
        class="size-[128px] border border-neutral-200 rounded-xl"
      />
      <button
        (click)="deleteImage($index)"
        class="absolute text-red-500 top-1 right-1"
      >
        <app-icon name="material-symbols-light:cancel">삭제</app-icon>
      </button>
    </div>

    }
  </section>

  <section class="flex gap-1 flex-col *:text-neutral-400 text-xs">
    <p>
      *첨부파일은 10MB 이하의 파일만 첨부 가능하며, 최대 5개까지 등록
      가능합니다.
    </p>
    <p>*올려주신 사진은 정보 업데이트시 사용될 수 있습니다.</p>
    <p>*저품질의 사진은 정보 제공이 불가할 수 있습니다.</p>
  </section>
</main>

<input
  class="hidden"
  id="app-profile-uploader"
  type="file"
  accept="image/*"
  multiple
/>
